// extracted by mini-css-extract-plugin
export var contentBlock = "content-block-module--content-block--1dgEx";
export var buttonLink = "content-block-module--button-link--2VAYc";
export var contentBlockContent = "content-block-module--content-block-content--1Ocoo";
export var contentBlockImage = "content-block-module--content-block-image--_aI6U";
export var contentBlockSummary = "content-block-module--content-block-summary--1CweO";